import { Grid, Theme } from '@mui/material';
import { NotificationCard } from '@components/notification/notificationCard/NotificationCard';
import { NotificationStatus, UserNotification } from '@models/notification';

export type NotificationsProps = {
  onClosePopover: () => void;
  notifications: UserNotification[];
  onNotificationChange: (status: NotificationStatus, notificationIds?: string[]) => void;
};

export const Notifications = (props: NotificationsProps) => {
  const { notifications, onNotificationChange, onClosePopover } = props;

  return (
    <>
      {(notifications || []).map((n) => (
        <Grid
          size={{ xs: 12 }}
          id={n?.id as string}
          key={n?.id as string}
          sx={{
            backgroundColor: (theme: Theme) => (theme.palette.theme === 'lio' ? 'primary.dark' : 'background.main'),
            width: '100%',
          }}
        >
          <NotificationCard
            onClosePopover={onClosePopover}
            onDismiss={() => {
              onNotificationChange(NotificationStatus.Dismissed, [n?.id as string]);
            }}
            onRead={() => {
              onNotificationChange(NotificationStatus.Read, [n?.id as string]);
            }}
            {...n}
          />
        </Grid>
      ))}
    </>
  );
};
